/**
 * 功能权限控制
 */
import { makeAutoObservable } from 'mobx'
import { PermissionApi } from 'api'
import { keyBy } from '@dt/fe-utils/dist/lodash'

class PermissionMobx {
  constructor () {
    makeAutoObservable(this)
  }
  permissionKeysMap: { [key: string]: IPermissionKeys } = {}

  /** 商城是否过期验证 */
  get getCheckMallExpire () {
    const type = 'online_store'
    return bo === 'cn' && this.permissionKeysMap[type]?.isExpire
  }

  async init (key: TPermissionKey) {
    if (this.permissionKeysMap[key]) {
      return true
    } else {
      try {
        const { result, success } = await PermissionApi.checkBrandPermissionByKey({
          permissionPackageKey: key
        })
        if (success) {
          this.permissionKeysMap[key] = result
          return true
        }
      } catch (error) {
      }
      return false
    }
  }

  /** 判断当前品牌是否有权限 */
  checkAuthToKey (key: TPermissionKey) {
    return this.permissionKeysMap[key]?.isExpire === true
  }
}

export default new PermissionMobx()
